export const FILTER_MENU = [
  {
    text: 'Организации',
    value: 'partner',
  },
  {
    text: 'Дата публикации',
    value: 'publish_date',
  },
  {
    text: 'Зарплата',
    value: 'salary',
  },
];

export const LIMITS = ['11', '23', '35'];
export const PAGE_SIZE = LIMITS[0];
export const PAGE_NUMBER = 1;
export const DEFAULT_SORT = 'partner';
export const STORE_MODULE_NAME = 'vacanciesList';
export const FETCH_ITEMS = 'fetchItems';
export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';
export const SET_PROFESSIONS = 'setProfessions';
export const FETCH_PROFESSIONS = 'fetchProfessions';
export const INIT = 'initVacanciesList';
export const SET_COMPETENCES = 'setCompetences';
export const FETCH_COMPETENCES = 'fetchCompetences';
export const SET_ORGANIZATIONS = 'setOrganizations';
export const FETCH_ORGANIZATIONS = 'fetchOrganizations';
export const SET_VACANCIES_PLACE_TYPE = 'setVacanciesPlaceType';
export const FETCH_VACANCIES_PLACE_TYPE = 'fetchVacanciesPlaceType';
export const SET_VACANCIES_EMPLOYMENT_TYPE = 'setVacanciesEmploymentType';
export const FETCH_VACANCIES_EMPLOYMENT_TYPE = 'fetchVacanciesEmploymentType';



// WEBPACK FOOTER //
// ./src/pages/vacancies/list/consts.ts